import useDebounce from "../../hooks/useDebounce";
import { Search } from '@mui/icons-material'
import React, { useEffect, useState } from 'react';
import { Chip, FormControl, Grid, MenuItem, Pagination, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { styled } from '@mui/system'
import "./rewardConfig.css"
import { useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import Loader from '../../components/Loader/Loader'
import Toptag from '../../components/toptag/Toptag'
import apiFunctions from '../../api/apiFunctions'


const NavPaper = styled(Paper)({
    padding: "5px 12px",
    borderRadius: "0",
    backgroundColor: "white",
    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
})

const BackPaper = styled(Paper)({
    minHeight: "calc(100vh - 130px)",
    overflow: "visible",
    boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px"
})

export default function RewardConfig() {

    const [all, setAll] = useState([]);
    const [activeConfig, setActiveConfig] = useState(null);
    const [allTags, setAllTags] = useState([]);
    const [isLoading, setIsloading] = useState(true)
    const [configsCount, setConfigsCount] = useState(0)
    const navigate = useNavigate();
    const [limit, setLimit] = useState(10);
    const [skip, setSkip] = useState('0');
    const [page, setPage] = useState("1")
    const [searchKey, setSearchKey] = useState("");
    const debouncedSearch = useDebounce(searchKey, 400);

    const searchHandle = (event) => {
        const newQuery = event.target.value;
        setSearchKey(newQuery)
        setSkip(0);
        setPage(1);
    }

    const handleConfigButton = () => {
        navigate("/home/reward-config/add");
    };

    const getAll = async () => {
        setIsloading(true);
        try {
            let result = await apiFunctions.getAllRewardConfigs(limit, searchKey, page);
            if (!result.data.status) {
                if (result.data.code === 401) {
                    localStorage.clear();
                    navigate("/login")
                    toast.info("Session Expired Please login again!!")
                }
                toast.error(result.data.message, {
                    position: toast.POSITION.TOP_RIGHT
                });
            } else {
                setAll(result.data.data);
                setConfigsCount(result.data.total_count)
            }
        } catch (error) {
            toast.error("Something went wrong!", {
                position: toast.POSITION.TOP_RIGHT
            });
        } finally {
            setIsloading(false)
        }
    }

    const getActiveConfig = async () => {
        let result = await apiFunctions.getActiveRewardConfig();
        if (result.data.status) {
            setActiveConfig(result.data.data);
        } else {
            setActiveConfig(null);
        }
    }

    const loadTags = async () => {
        try {
            const result = await apiFunctions.getAllTag(500, '', 1);
            if (result.data.status) {
                setAllTags(result.data.data || []);
            }
        } catch (error) {
            // NOTE: tag titles are optional for list display
        }
    }

    const formatEmissionThreshold = (value) => {
        if (value === null || value === undefined) return 'None';
        return Number(value).toLocaleString();
    }

    const formatBonusTags = (tagIds) => {
        if (!Array.isArray(tagIds) || tagIds.length === 0) return 'None';
        return tagIds.map((tagId) => {
            const id = typeof tagId === 'object' ? String(tagId._id) : String(tagId);
            const tag = allTags.find((t) => String(t._id) === id);
            return tag ? tag.title : id;
        }).join(', ');
    }

    const formatBonusMultiplier = (value) => {
        const multiplier = value != null ? value : 2;
        return `${multiplier}x`;
    }

    const formatMinEmissionRequired = (value) => {
        if (value === null || value === undefined) return 'None';
        return Number(value).toLocaleString();
    }

    const formatSpecialEvents = (enabled) => {
        return enabled === false ? 'Disabled' : 'Enabled';
    }

    const formatExcludeTags = (tagIds) => {
        if (!Array.isArray(tagIds) || tagIds.length === 0) return 'None';
        return formatBonusTags(tagIds);
    }

    useEffect(() => {
        getAll()
        getActiveConfig()
        loadTags()
    }, [debouncedSearch, limit, page])

    const handleChange = (e) => {
        const v = Number(e.target.value)   // Select returns a string; coerce so "All" matches
        if (v === configsCount) {
            setSkip(0)
            setLimit(configsCount)
        } else {
            setLimit(v)
        }
    };

    const skipPagination = (e, page) => {
        setSkip((page - 1) * limit)
        setPage(page)
    }

    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        let date = new Date(dateString);
        let monthsArray = ["Jan", "Feb", "March", "Apr", "May", "Jun", "July", "Aug", "Sept", "Oct", "Nov", "Dec",];
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        return `${date.getDate()} ${monthsArray[date.getMonth()]} ${date.getFullYear()}, ${hours}:${minutes} ${ampm}`;
    }

    return (
        <>
            <div className='container'>
                        <Toptag />
                        <ToastContainer autoClose={1000} />
                        <NavPaper>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div></div>
                                <Grid container spacing={4} direction="row" justifyContent="flex-end" alignItems="center">
                                    <Grid item><div style={{ fontSize: "15px", fontWeight: "400", color: "grey" }}>Total Configs - {configsCount}</div></Grid>
                                    <Grid item><div style={{ fontSize: "15px", fontWeight: "400", color: "grey" }}>Row Per Page - </div></Grid>
                                    <Grid item>
                                        <FormControl variant="standard" sx={{ m: 1, minWidth: 50 }}>
                                            <Select
                                                labelId="demo-simple-select-standard-label"
                                                id="demo-simple-select-standard-label"
                                                value={limit}
                                                onChange={handleChange}
                                            >
                                                <MenuItem value="5">5</MenuItem>
                                                <MenuItem value="10">10</MenuItem>
                                                <MenuItem value="20">20</MenuItem>
                                                <MenuItem value="30">30</MenuItem>
                                                <MenuItem value={configsCount}>All</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    
                                    <Grid item>
                                        <button className='newBtn' onClick={handleConfigButton}>
                                            {activeConfig ? 'Update Config' : 'Add Config'}
                                        </button>
                                    </Grid>
                                </Grid>

                            </div>
                        </NavPaper>
                        {isLoading ? (
                    <Loader />) : (
                    <>
                        {activeConfig && (
                            <NavPaper style={{ marginTop: "10px", padding: "15px", backgroundColor: "#e8f5e9" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <div>
                                        <div style={{ fontSize: "16px", fontWeight: "600", marginBottom: "8px" }}>Active Configuration</div>
                                        <div style={{ fontSize: "14px", color: "grey", marginBottom: "6px" }}>
                                            <span style={{ fontWeight: "600", color: "#444" }}>Generation:</span>{" "}
                                            Min Users: {activeConfig.minimum_users_required} |
                                            Hourly USD: ${activeConfig.amount_per_hour} |
                                            Min Emission Gate: {formatMinEmissionRequired(activeConfig.min_emission_required)} |
                                            Special Events: {formatSpecialEvents(activeConfig.special_events_rewards_enabled)} |
                                            Exclude Tags: {formatExcludeTags(activeConfig.exclude_tag_ids)}
                                        </div>
                                        <div style={{ fontSize: "14px", color: "grey" }}>
                                            <span style={{ fontWeight: "600", color: "#444" }}>Bonus:</span>{" "}
                                            Multiplier: {formatBonusMultiplier(activeConfig.bonus_multiplier)} |
                                            Emission: {formatEmissionThreshold(activeConfig.bonus_emission_threshold)} |
                                            Tags: {formatBonusTags(activeConfig.bonus_tag_ids)} |
                                            Created: {formatDateTime(activeConfig.createdAt)}
                                        </div>
                                    </div>
                                    <Chip label="Active" className="statusChipActive" />
                                </div>
                            </NavPaper>
                        )}
                        <BackPaper>
                            {all.length === 0 && searchKey ?
                                <Grid container spacing={2} style={{ marginTop: "30px" }} direction="column" justifyContent="space-evenly" alignItems="center">
                                    <Grid item><img src="/images/nodata.jpg" alt="error-image" style={{ height: "150px", width: "200px" }} /></Grid>
                                    <Grid item><div className="errorMessage">Reward Configs not found!</div></Grid>
                                </Grid> :
                                <>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>S.No</TableCell>
                                                <TableCell>Min Users Required</TableCell>
                                                <TableCell>Hourly USD</TableCell>
                                                <TableCell>Bonus Multiplier</TableCell>
                                                <TableCell>Emission Bonus</TableCell>
                                                <TableCell>Bonus Tags</TableCell>
                                                <TableCell>Min Emission Gate</TableCell>
                                                <TableCell>Special Events</TableCell>
                                                <TableCell>Exclude Tags</TableCell>
                                                <TableCell>Created By</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Created At</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>

                                            {all.map((element, index) => {
                                                return (<>
                                                    <TableRow key={index + 1} style={{ backgroundColor: element.is_active ? '#f1f8e9' : 'white' }}>
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>{element.minimum_users_required}</TableCell>
                                                        <TableCell>${element.amount_per_hour}</TableCell>
                                                        <TableCell>{formatBonusMultiplier(element.bonus_multiplier)}</TableCell>
                                                        <TableCell>{formatEmissionThreshold(element.bonus_emission_threshold)}</TableCell>
                                                        <TableCell>{formatBonusTags(element.bonus_tag_ids)}</TableCell>
                                                        <TableCell>{formatMinEmissionRequired(element.min_emission_required)}</TableCell>
                                                        <TableCell>{formatSpecialEvents(element.special_events_rewards_enabled)}</TableCell>
                                                        <TableCell>{formatExcludeTags(element.exclude_tag_ids)}</TableCell>
                                                        <TableCell>{element.created_by?.user_name || 'N/A'}</TableCell>
                                                        <TableCell>
                                                            {element.is_active === true ? (
                                                                <Chip label="Active" className="statusChipActive" />
                                                            ) : (
                                                                <Chip label="Inactive" className="statusChipBlock" />
                                                            )}
                                                        </TableCell>
                                                        <TableCell>{formatDateTime(element.createdAt)}</TableCell>
                                                    </TableRow>
                                                </>
                                                )
                                            })}
                                        </TableBody>
                                    </Table>
                                </>
                            }

                            <div style={{ display: 'flex', flexDirection: "row", justifyContent: "center", alignItems: 'center', marginTop: "20px", marginBottom: "20px" }}>
                                <div>
                                    <Pagination count={Math.ceil(configsCount / limit)} page={Math.floor(skip / limit) + 1} variant="outlined" onChange={skipPagination} shape="rounded" />
                                </div>
                            </div>
                        </BackPaper>

                    </>
                )}
            </div>
        </>
    )
}
